import { render, staticRenderFns } from "./_uuid.vue?vue&type=template&id=632ea3b0&scoped=true"
import script from "./_uuid.vue?vue&type=script&lang=js"
export * from "./_uuid.vue?vue&type=script&lang=js"
import style0 from "./_uuid.vue?vue&type=style&index=0&id=632ea3b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632ea3b0",
  null
  
)

export default component.exports